import { TopDestinationCard } from './TopDestinationCard';

export default TopDestinationCard;
